const Loading = () => {
    return (
        <div className="loading">
            <span className="loading__indicator loading__indicator--one"></span>
            <span className="loading__indicator loading__indicator--two"></span>
            <span className="loading__indicator loading__indicator--three"></span>
        </div>
    );
}
 
export default Loading;